// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"759161c7","163":"08800c1a","225":"e2837913","239":"e39fb35b","430":"49536318","444":"d7137153","455":"a9ba13ed","485":"4ca0549b","793":"4ee1d795","825":"3b0d33ad","906":"1fbb8fb7","939":"4bdf96e5","977":"240addac"}[chunkId] + ".chunk.js";
};